module.exports = __webpack_public_path__ + "img/54.15aad680.jpg";